import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import TitleMain from "../../components/Title/TitleMain";
import {useModal} from "../../contexts/ModalContext";
import TitleSecondary from "../../components/Title/TitleSecondary";
import {useUser} from "../../contexts/UserContext";
import {
    getStatsMainPage, getStatsTabSeancesPage, getStatsTabUsersPage,
} from "../../services/StatsService";
import SeancesStatsTable from "../../components/Seance/SeancesStatsTable";
import UsersStatsTable from "../../components/Seance/UsersStatsTable";
import styles from "./Statistiques.module.css";
import FilterHamburgerCustom from "../../components/Filter/FilterHamburgerCustom";
import SearchEntreprise from "../../components/Search/SearchEntreprise";
import styles_filter from "../../components/Filter/Filter.module.css";
import {ReactComponent as AnnulerIcon} from "../../icons/annuler.svg";
import {exportToCsv} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import {updateFilterUri} from "../../services/FilterService";
import styles_field from "../../components/Field/Field.module.css";
import FieldCheckbox from "../../components/Field/FieldCheckbox";
import PaginationBar from "../../components/Pagination/PaginationBar";
import {login} from "../../services/AuthService";
import { ReactComponent as UncheckedIcon } from "../../icons/unchecked.svg";
import { ReactComponent as CheckedIcon } from "../../icons/checked.svg";
import DateService from "../../services/DateService";

function TabUsersStatsPage() {
    const {user} = useUser();
    const {showModal} = useModal();
    const [users, setUsers] = useState([]);
    const [filterConfirmationDateDebut, setFilterConfirmationDateDebut] = useState('');
    const [filterConfirmationDateFin, setFilterConfirmationDateFin] = useState('');
    const [filterParticipationDateDebut, setFilterParticipationDateDebut] = useState('');
    const [filterParticipationDateFin, setFilterParticipationDateFin] = useState('');
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [showNbParticipationDateInputs, setShowNbParticipationDateInputs] = useState(false);
    const months = DateService.getMonths();
    const currentMonthIndex = new Date().getMonth();
    const sortedMonths = [
        months[currentMonthIndex],
        ...months.slice(0, currentMonthIndex).reverse(),
        ...months.slice(currentMonthIndex + 1).reverse()
    ];
    const [selectedMonthParticipation, setSelectedMonthParticipation] = useState(DateService.getPreviousMonth());
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(null);
    const [totalResult, setTotalResult] = useState(null);
    const [sortBy, setSortBy] = useState([]);
    const prevSortBy = useRef(sortBy);

    const handleMonthChange = (event) => {
        setSelectedMonthParticipation(event.target.value);
    };

    const handleConfirmationDateDebutChange = (event) => {
        setFilterConfirmationDateDebut(event.target.value);
    };

    const handleConfirmationDateFinChange = (event) => {
        setFilterConfirmationDateFin(event.target.value);
    };

    const handleParticipationDateDebutChange = (event) => {
        setFilterParticipationDateDebut(event.target.value);
    };

    const handleParticipationDateFinChange = (event) => {
        setFilterParticipationDateFin(event.target.value);
    };

    const applyDateConfirmationFilter = () => {
        const dateFilterValue = `${filterConfirmationDateDebut},${filterConfirmationDateFin}`;
        updateFilter('filter_confirmation_date', dateFilterValue, true);
    };

    const applyDateParticipationFilter = () => {
        const dateFilterValue = `${filterParticipationDateDebut},${filterParticipationDateFin}`;
        updateFilter('filter_participation_date', dateFilterValue, true);
    };

    const handleSuccess = useCallback((message = "Statistiques récupérées") => {
        showModal('success', {children: message, timeout: 1500});
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', {children: message, timeout: 1500});
    }, [showModal]);

    const fetchData = async () => {
        const queryParams = location.search;
        const rez = await getStatsTabUsersPage(queryParams);
        if (rez.success === true || rez.success === "true") {
            if (rez.data) {
                setUsers(rez.data);
                setTotalPage(rez.totalPages);
                setTotalResult(rez.totalResult);
            } else {
                handleError("Pas de données pour les activités");
            }
        } else {
            handleError(rez.message);
        }
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, {replace: true});
    };

    const handleCheckboxChange = () => {
        setShowNbParticipationDateInputs(!showNbParticipationDateInputs);
    };

    const filterChildren = (
        <div>
            <TitleSecondary text={"Filtres"}/>

            <div className={styles_filter.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        let strValue = value;
                        let strKey = key.replace('filter_', '');
                        if (key === "filter_civilite") {
                            strValue = value == 4 ? "Homme" : "Femme";
                        }

                        if (key === "filter_date") {
                            const date1 = value.split(',')[0];
                            const date2 = value.split(',')[1];
                            strValue = ` ${DateService.formatFrenchDateWithoutTime(date1)} au ${DateService.formatFrenchDateWithoutTime(date2)}`;
                        }

                        if (key === "filter_status") {
                            if (value === "compte_cree"){
                                strValue = "Compte créé";
                            }
                        }

                        if (key === "filter_participation_date") {
                            strKey = "Date de participation";
                            const date1 = value.split(',')[0];
                            const date2 = value.split(',')[1];
                            strValue = ` ${DateService.formatFrenchDateWithoutTime(date1)} au ${DateService.formatFrenchDateWithoutTime(date2)}`;
                        }


                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcon/>
                                <span className={"filter_key"}>{strKey}</span> : {strValue}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}>
                {user.roles.includes("ROLE_ADMIN") && <div><p>Entreprise</p><SearchEntreprise onSubmit={(entr) => {
                    updateFilter('filter_entrepriseId', entr.entrepriseId, true);
                }}/></div>}

                <div>
                    <span>Civilité</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_civilite', '4', true)}>Homme
                        </button>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_civilite', '3', true)}>Femme
                        </button>
                    </div>
                </div>

                <div>
                    <span>Statut</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_status', "compte_cree", true)}>Compte créé
                        </button>
                    </div>
                </div>

                <div>
                    <span>Confirmation de compte</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <div>
                            <span>De </span>
                            <input
                                type="date"
                                value={filterConfirmationDateDebut}
                                onChange={handleConfirmationDateDebutChange}
                                className={styles_field.inputy}
                            />

                            <span> à </span>
                            <input
                                type="date"
                                value={filterConfirmationDateFin}
                                onChange={handleConfirmationDateFinChange}
                                className={styles_field.inputy}
                            />
                        </div>

                        <button onClick={applyDateConfirmationFilter} className={"btn"}>< FontAwesomeIcon icon={faFilter} /></button>
                    </div>
                </div>

                <div>
                    <span>A une participation</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        {showNbParticipationDateInputs ? (
                            <div>
                                Entre le <input
                                className={styles_field.inputy}
                                type="date"
                                value={filterParticipationDateDebut}
                                onChange={handleParticipationDateDebutChange}
                            /> et <input
                                className={styles_field.inputy}
                                type="date"
                                value={filterParticipationDateFin}
                                onChange={handleParticipationDateFinChange}
                            />
                            </div>
                        ) : (
                            <div>
                                <label htmlFor="monthSelector">Pour le mois de </label>
                                <select id="monthSelector" value={selectedMonthParticipation}
                                        className={styles_field.inputy}
                                        onChange={handleMonthChange}>
                                    {sortedMonths.map((month, index) => (
                                        <option key={index} value={month}>
                                            {month} {months.indexOf(month) <= new Date().getMonth() ? new Date().getFullYear() : new Date().getFullYear() - 1}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div>
                            <label htmlFor="deb" style={{fontSize: "0.8rem"}}>Dates
                                libre {showNbParticipationDateInputs ?
                                    <CheckedIcon style={{height: "16px", width: "16px"}}/> :
                                    <UncheckedIcon style={{height: "16px", width: "16px"}}/>}</label>
                            <input
                                type={"checkbox"}
                                id={"deb"}
                                name={"hide_input_part"}
                                value={"deb"}
                                onChange={handleCheckboxChange}
                                style={{display: "none"}}
                            />
                        </div>

                        <div>
                            <button onClick={applyDateParticipationFilter} className={"btn"}>< FontAwesomeIcon icon={faFilter} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const onSortChange = ({ sortBy }) => {
        if (JSON.stringify(sortBy) !== JSON.stringify(prevSortBy.current)) {
            prevSortBy.current = sortBy;
            setSortBy(sortBy);
        }
    };

    const getInitialSortBy = () => {
        const sortBy = [];
        params.getAll('sort_by').forEach((id, index) => {
            sortBy.push({ id, desc: params.getAll('sort_desc')[index] === 'true' });
        });
        return sortBy;
    };


    useEffect(() => {
        if (!user) return;

        fetchData();
    }, [user, location.search]);

    useEffect(() => {
        if (sortBy.length > 0) {
            params.delete('sort_by');
            params.delete('sort_desc');
            sortBy.forEach(sort => {
                params.append('sort_by', sort.id);
                params.append('sort_desc', sort.desc);
            });
            navigate(`${location.pathname}?${params.toString()}`);
        }
    }, [sortBy]);

    useEffect(() => {
        const monthIndex = months.indexOf(selectedMonthParticipation);
        const currentMonthIndex = new Date().getMonth();

        let year = new Date().getFullYear();
        if (monthIndex > currentMonthIndex) {
            year -= 1;
        }

        const startDate = DateService.getStartOfMonth(year, monthIndex);
        const endDate = DateService.getEndOfMonth(year, monthIndex);
        setFilterParticipationDateDebut(startDate);
        setFilterParticipationDateFin(endDate);
    }, [selectedMonthParticipation]);

    useEffect(() => {
        if (page) {
            params.set('page', page);
            navigate(`${location.pathname}?${params.toString()}`);
        }
    }, [page]);

    return (
        <div className="content_tab">
            <TitleMain text={"Statistiques des utilisateurs"}/>

            <div className={styles.mobileMessage}>
                Pour une meilleure expérience, veuillez consulter ce tableau sur un ordinateur de bureau ou un écran
                plus
                grand.
            </div>

                <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)}
                                       children={filterChildren}/>

            {/*
                <button className={"btn"} style={{
                    backgroundColor: "#e7f1e6",
                    border: "2px solid var(--clr-accent)",
                    height: "fit-content"
                }} onClick={() => exportToCsv('users.csv', users)} title={"Télécharger le tableau"}>
                    <FontAwesomeIcon icon={faDownload}/>
                </button>
            */}

            <div className={styles.tableau}>
                <UsersStatsTable users={users} serverSideSorting={true} onSortChange={onSortChange} initialSortBy={getInitialSortBy()}/>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalResult}/>
                </div>
            </div>

        </div>
    )
}

export default TabUsersStatsPage;
